import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { showNotification } from '../../../StatusNotification';
import { showConfirmation } from '../../../ConfirmationModal';

export class ActionButtonForm extends Component {
    static displayName = ActionButtonForm.name;

    constructor(props) {
        super(props);
        this.state = {
            actionButton: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newActionButton = this.state.actionButton;
        newActionButton[e.target.name] = e.target.value;
        this.setState({ actionButton: newActionButton });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let actionButton = this.state.actionButton;
        actionButton.versionId = this.state.versionId;
        actionButton.pageId = this.state.pageId;
        let url = this.state.formType == "Update" ? "UpdateActionButton" : "CreateActionButton";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(actionButton),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                    var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "ActionButton", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    
                    //window.location = '/UpdatePageComponent/' + this.state.pageId;
                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        let link = null;
        let text = null;
        let componentName = null;

        if (this.state.actionButton != null) {
            let actionButton = this.state.actionButton;
            link = actionButton.link;
            text = actionButton.text;
            componentName = actionButton.componentName;
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <form onSubmit={this.handleSubmit} className={wrapperClasses}>
                <div className='dual-grid'>
                    <div className='dual-grid__1-2 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('ActionButton')}</h2>
                    </div>
                   
                    <label htmlFor='actionBtn-componentName'>Component Name:</label>
                    <input id='actionBtn-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />

                    <label htmlFor='actionBtn-link'>Link: </label>
                    <input id='actionBtn-link' name='link' type='text' defaultValue={link} onChange={this.handleChange} required />

                    <label htmlFor='actionBtn-text'>Text: </label>
                    <input id='actionBtn-text' name='text' type='text' defaultValue={text} onChange={this.handleChange} required />

                    <div className='dual-grid__1-2'>
                        <button type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetActionButton?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            actionButton: data,
            formType: formType
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteActionButton?componentId=' + this.state.actionButton.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                //window.location = '/UpdatePageComponent/' + this.state.pageId;
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default ActionButtonForm;